module.exports = __webpack_public_path__ + "img/Picture4.28ffa32a.jpg";